<template>
    <v-dialog
        :value="show"
        max-width="95vw"
        width="95vw"
        @click:outside="$emit('close')"
    >
        <v-card class="packaging-edit-dialog full-screen-dialog" :style="{ height: '95vh' }">
            <!-- Close Button -->
                                            <v-btn
                icon 
                large
                color="grey"
                @click="$emit('close')"
                class="close-button-fixed"
            >
                <v-icon size="24">mdi-close</v-icon>
                                            </v-btn>

            <!-- Compact Header Section -->
            <div class="packaging-header-compact">
                <div class="header-content-compact">
                    <div class="header-image-compact">
                        <img v-if="editedItem.img" :src="editedItem.img" alt="Packaging" />
                        <div v-else class="no-image-placeholder-compact">
                            <v-icon size="32" color="white">mdi-package-variant</v-icon>
                                </div>
                            </div>
                    <div class="header-info-compact">
                        <h3 class="packaging-title-compact">{{ editedItem.title || 'Unbenannte Kartonage' }}</h3>
                        <div class="packaging-details-compact">
                            <span class="detail-chip">{{ editedItem.sku || 'N/A' }}</span>
                            <span class="detail-chip">€{{ editedItem.pricePerUnit || '0.00' }}</span>
                            <span class="detail-chip">{{ editedItem.weight || '0' }}g</span>
                            <span class="detail-chip">{{ editedItem.lengthCm || '0' }}×{{ editedItem.widthCm || '0' }}×{{ editedItem.heightCm || '0' }}cm</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Scrollable Content -->
            <v-card-text class="packaging-content">
                
                <!-- Top Row: Information and Media Side by Side -->
                <v-row class="top-sections mb-6">
                    <!-- Left Column: Kartonage Informationen -->
                    <v-col cols="12" lg="6" class="pr-lg-3">
                        <div class="edit-section">
                    <h2 class="section-title">
                        <v-icon color="primary" class="mr-2">mdi-pencil</v-icon>
                        Kartonage Informationen
                    </h2>
                    
                    <v-card outlined class="section-card">
                        <v-card-text class="pa-4">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="editedItem.title"
                                        label="Bezeichnung"
                                        outlined
                                        dense
                                        hide-details
                                        class="mb-4"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="editedItem.sku"
                                        label="SKU"
                                        outlined
                                        dense
                                        hide-details
                                        class="mb-4"
                                        disabled
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model.number="editedItem.lengthCm"
                                        label="Länge"
                                        type="number"
                                        suffix="cm"
                                        outlined
                                        dense
                                        hide-details
                                        class="mb-4"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model.number="editedItem.widthCm"
                                        label="Breite"
                                        type="number"
                                        suffix="cm"
                                        outlined
                                        dense
                                        hide-details
                                        class="mb-4"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        v-model.number="editedItem.heightCm"
                                        label="Höhe"
                                        type="number"
                                        suffix="cm"
                                        outlined
                                        dense
                                        hide-details
                                        class="mb-4"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model.number="editedItem.weight"
                                        label="Gewicht"
                                        type="number"
                                        suffix="g"
                                        outlined
                                        dense
                                        hide-details
                                        class="mb-4"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model.number="editedItem.pricePerUnit"
                                        label="Preis pro Stück"
                                        type="number"
                                        prefix="€"
                                        outlined
                                        dense
                                        hide-details
                                        class="mb-4"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-textarea
                                v-model="editedItem.description"
                                label="Beschreibung"
                                outlined
                                dense
                                hide-details
                                rows="3"
                                class="mb-4"
                            ></v-textarea>
                        </v-card-text>
                    </v-card>
                        </div>
                    </v-col>
                    
                    <!-- Right Column: Medien -->
                    <v-col cols="12" lg="6" class="pl-lg-3">
                        <!-- Section 2: Medien -->
                <div class="media-section">
                    <h2 class="section-title">
                        <v-icon color="primary" class="mr-2">mdi-image</v-icon>
                        Medien
                    </h2>
                    
                    <v-card outlined class="section-card">
                        <v-card-text class="pa-4 sku-linking-section">
                            <!-- Image Upload/Replace Area -->
                            <div 
                                class="image-upload-area"
                                :class="{ 'drag-over': isDragOver, 'uploading': isUploading, 'has-image': hasCurrentImage }"
                                @dragover.prevent="handleDragOver"
                                @dragleave.prevent="handleDragLeave"
                                @drop.prevent="handleDrop"
                                @click="triggerFileInput"
                            >
                                <input
                                    ref="fileInput"
                                    type="file"
                                    accept="image/*"
                                    @change="onFileInput"
                                    style="display: none;"
                                />
                                
                                <!-- Current Image Display (if exists) -->
                                <div v-if="hasCurrentImage && !isUploading" class="current-image-display">
                                    <div class="current-image-container">
                                        <img :src="editedItem.img" alt="Current Image" class="current-image" />
                                        <div class="image-overlay">
                                            <v-icon size="32" color="white" class="mb-2">mdi-camera-enhance</v-icon>
                                            <p class="overlay-text">Bild ersetzen</p>
                                        </div>
                                    </div>
                                    <div class="image-actions mt-3">
                                        <v-btn color="primary" outlined>
                                            <v-icon left>mdi-upload</v-icon>
                                            Neues Bild hochladen
                                        </v-btn>
                                        <v-btn color="error" text @click="removeCurrentImage">
                                            <v-icon left>mdi-delete</v-icon>
                                            Bild entfernen
                                        </v-btn>
                                    </div>
                                </div>
                                
                                <!-- Upload Area (no current image) -->
                                <div v-else-if="!hasCurrentImage && !isUploading" class="upload-empty-state">
                                    <v-icon size="48" color="primary" class="mb-3">mdi-cloud-upload</v-icon>
                                    <h3 class="text-h6 font-weight-medium mb-2">Bild hochladen</h3>
                                    <p class="text-body-2 grey--text mb-3">
                                        Drag & Drop oder klicken zum Auswählen
                                    </p>
                                    <v-btn color="primary" outlined>
                                        <v-icon left>mdi-file-image</v-icon>
                                        Bild auswählen
                                    </v-btn>
                                </div>
                                
                                <!-- Upload Progress -->
                                <div v-else class="upload-progress">
                                    <v-progress-circular
                                        indeterminate
                                        color="primary"
                                        size="48"
                                        class="mb-3"
                                    ></v-progress-circular>
                                    <p class="text-body-2">{{ uploadStatus }}</p>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                        </div>
                    </v-col>
                </v-row>

                <!-- Section 3: SKU Zuweisung -->
                <div class="sku-section">
                    <h2 class="section-title">
                        <v-icon color="primary" class="mr-2">mdi-link-variant</v-icon>
                        SKU Zuweisung
                    </h2>
                    
                    <v-card outlined class="section-card">
                        <v-card-text class="pa-4">
                            <!-- Filter Selection Area -->
                            <div class="filter-selection-area mb-4">
                                <!-- Shop Selection Row -->
                                <div class="mb-4">
                                    <h4 class="text-subtitle-1 mb-3">
                                        <v-icon color="primary" class="mr-2">mdi-filter</v-icon>
                                        Filter & Suche
                                    </h4>
                                    <div class="shop-checkboxes mb-3">
                                        <v-checkbox
                                            v-for="shop in shops"
                                            :key="shop"
                                            v-model="selectedShops"
                                            :value="shop"
                                            :label="shop.charAt(0).toUpperCase() + shop.slice(1)"
                                            class="shop-checkbox"
                                            :color="getShopColorName(shop)"
                                            hide-details
                                        >
                                            <template v-slot:label>
                                                <div class="shop-label">
                                                    <v-icon 
                                                        :color="selectedShops.includes(shop) ? getShopColorName(shop) : 'grey'" 
                                                        class="mr-2"
                                                        small
                                                    >
                                                        {{ getShopIcon(shop) }}
                                                    </v-icon>
                                                    <span :class="selectedShops.includes(shop) ? `${getShopColorName(shop)}--text font-weight-bold` : 'grey--text'">
                                                        {{ shop.charAt(0).toUpperCase() + shop.slice(1) }}
                                                    </span>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                    </div>
                                </div>

                                <!-- Product & Category Selection Row -->
                            <v-row>
                                    <v-col cols="12" md="4">
                                        <v-autocomplete
                                            v-model="selectedProducts"
                                            :items="availableProducts"
                                            label="Produkte auswählen"
                                            outlined
                                            dense
                                        multiple
                                            chips
                                            deletable-chips
                                            small-chips
                                            clearable
                                            hide-details
                                            :search-input.sync="productSearchInput"
                                            no-data-text="Keine Produkte gefunden"
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip 
                                                    v-if="index === 0"
                                                    small 
                                                    color="primary" 
                                                    dark
                                                    class="mr-1"
                                                >
                                                    <v-icon left x-small>mdi-package-variant</v-icon>
                                                    {{ item }}
                                                </v-chip>
                                                <span
                                                    v-if="index === 0 && selectedProducts.length > 1"
                                                    class="grey--text caption ml-2"
                                                >
                                                    (+{{ selectedProducts.length - 1 }} weitere)
                                                </span>
                                            </template>
                                            <template v-slot:item="{ item }">
                                                <div class="d-flex align-center justify-space-between w-100">
                                                    <div class="d-flex align-center">
                                                        <v-icon color="primary" class="mr-3" small>mdi-package-variant</v-icon>
                                                        <span class="font-weight-medium">{{ item }}</span>
                                                    </div>
                                                    <v-chip x-small color="grey" outlined>
                                                        {{ getProductSkuCount(item) }} SKUs
                                                    </v-chip>
                                                </div>
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-autocomplete
                                            v-model="selectedCategories"
                                            :items="availableCategories"
                                            label="Kategorien auswählen"
                                        outlined
                                        dense
                                            multiple
                                            chips
                                            deletable-chips
                                            small-chips
                                            clearable
                                        hide-details
                                            :search-input.sync="categorySearchInput"
                                            no-data-text="Keine Kategorien gefunden"
                                    >
                                            <template v-slot:selection="{ item, index }">
                                            <v-chip
                                                    v-if="index === 0"
                                                small
                                                    color="secondary" 
                                                    dark
                                                class="mr-1"
                                            >
                                                    <v-icon left x-small>mdi-shape</v-icon>
                                                    {{ item }}
                                            </v-chip>
                                            <span
                                                    v-if="index === 0 && selectedCategories.length > 1"
                                                    class="grey--text caption ml-2"
                                            >
                                                    (+{{ selectedCategories.length - 1 }} weitere)
                                            </span>
                                        </template>
                                            <template v-slot:item="{ item }">
                                                <div class="d-flex align-center justify-space-between w-100">
                                                    <div class="d-flex align-center">
                                                        <v-icon color="secondary" class="mr-3" small>mdi-shape</v-icon>
                                                        <span class="font-weight-medium">{{ item }}</span>
                                                    </div>
                                                    <v-chip x-small color="grey" outlined>
                                                        {{ getCategorySkuCount(item) }} SKUs
                                                    </v-chip>
                                                </div>
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            v-model="skuSearch"
                                            label="SKU suchen"
                                            outlined
                                            dense
                                            hide-details
                                            prepend-inner-icon="mdi-magnify"
                                            clearable
                                            :disabled="selectedProducts.length === 0 && selectedCategories.length === 0"
                                            :placeholder="(selectedProducts.length > 0 || selectedCategories.length > 0) ? 'SKUs durchsuchen...' : 'Erst Filter auswählen'"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            </div>

                            <!-- Results Summary -->
                            <div class="results-summary mb-3">
                                <v-chip color="info" dark class="mr-2">
                                    <v-icon left small>mdi-database</v-icon>
                                    {{ filteredTranslations.length }} Einträge gefunden
                                </v-chip>
                                <v-chip v-if="selectedProducts.length > 0" color="primary" dark class="mr-2">
                                    <v-icon left small>mdi-package-variant</v-icon>
                                    {{ selectedProducts.length }} Produkte
                                </v-chip>
                                <v-chip v-if="selectedCategories.length > 0" color="secondary" dark class="mr-2">
                                    <v-icon left small>mdi-shape</v-icon>
                                    {{ selectedCategories.length }} Kategorien
                                </v-chip>
                            </div>

                            <!-- Selection Actions -->
                            <div class="selection-actions mb-3">
                                <v-row align="center">
                                    <v-col cols="auto">
                                        <v-btn
                                            small
                                            color="primary"
                                            outlined
                                            @click="selectAllMatchingSkus"
                                            :disabled="filteredTranslations.length === 0"
                                        >
                                            <v-icon left small>mdi-select-all</v-icon>
                                            Alle Gefundenen Auswählen ({{ filteredTranslations.length }})
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="auto">
                                            <v-btn
                                                small
                                            color="grey"
                                            outlined
                                            @click="clearAllSelections"
                                            :disabled="selectedTranslations.length === 0"
                                        >
                                            <v-icon left small>mdi-select-off</v-icon>
                                            Auswahl Leeren
                                            </v-btn>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-chip 
                                            small 
                                            :color="selectedTranslations.length > 0 ? 'success' : 'grey'" 
                                            :dark="selectedTranslations.length > 0"
                                        >
                                            <v-icon left x-small>
                                                {{ selectedTranslations.length > 0 ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                                            </v-icon>
                                            {{ selectedTranslations.length }} von {{ filteredTranslations.length }} ausgewählt
                                        </v-chip>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-btn
                                            color="primary"
                                            small
                                            :disabled="selectedTranslations.length === 0"
                                            @click="updateSkuLinks"
                                        >
                                            <v-icon left small>mdi-link</v-icon>
                                            Verknüpfungen aktualisieren ({{ selectedTranslations.length }})
                                        </v-btn>
                                </v-col>
                            </v-row>
                            </div>

                            <!-- SKU/Translation Table -->
                            <div class="sku-table-container">
                                <v-data-table
                                    v-model="selectedTranslations"
                                    :headers="translationHeaders"
                                    :items="filteredTranslations"
                                    :search="globalSearch"
                                    item-key="id"
                                    show-select
                                    dense
                                    class="elevation-1"
                                    :items-per-page="25"
                                    :footer-props="{ 
                                        itemsPerPageOptions: [10, 25, 50, 100],
                                        showFirstLastPage: true,
                                        showCurrentPage: true
                                    }"
                                >
                                    <template v-slot:item.shop="{ item }">
                                        <v-chip 
                                            x-small 
                                            dark
                                            :style="{ 
                                                backgroundColor: getShopColor(item.shop),
                                                color: 'white'
                                            }"
                                            class="shop-badge"
                                        >
                                            <v-icon left x-small color="white">{{ getShopIcon(item.shop) }}</v-icon>
                                            {{ item.shop.toUpperCase() }}
                                        </v-chip>
                                    </template>
                                    
                                    <template v-slot:item.sku="{ item }">
                                        <span class="font-weight-medium">{{ item.sku }}</span>
                                    </template>
                                    
                                    <template v-slot:item.carton="{ item }">
                                        <v-chip v-if="item.carton" x-small color="orange" outlined>
                                            {{ item.carton }}
                                        </v-chip>
                                        <span v-else class="grey--text">-</span>
                                    </template>
                                </v-data-table>
                            </div>

                        </v-card-text>
                    </v-card>
                </div>
            </v-card-text>

            <v-card-actions class="compact-footer">
                <v-spacer></v-spacer>
                <v-btn
                    text
                    @click="$emit('close')"
                >
                    Abbrechen
                </v-btn>
                <v-btn
                    color="primary"
                    :loading="saving"
                    @click="handleSubmit"
                >
                    Speichern
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import PackagingService from '@/services/PackagingService';
import TranslatorService from '@/services/TranslatorService';

export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        item: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            uniqueSkus: [],
            editedItem: {},
            selectedSkus: [],
            newImages: [],
            saving: false,
            isDragOver: false,
            isUploading: false,
            uploadStatus: '',
            shops: [
                'acs',
                'amazon',
                'etsy',
                'muckelmeister',
                'shopify'
            ],
            translations: [],
            selectedShops: [],
            selectedProducts: [],
            selectedCategories: [],
            productSearchInput: '',
            categorySearchInput: '',
            skuSearch: '',
            selectedTranslations: [],
            translationHeaders: [
                { text: 'Shop', value: 'shop', width: '120px' },
                { text: 'SKU', value: 'sku', width: '250px' },
                { text: 'Tabelle', value: 'table', width: '150px' },
                { text: 'Karton', value: 'carton', width: '150px' }
            ]
        }
    },

    computed: {
        availableCategories() {
            // Get unique categories from uniqueSkus
            return [...new Set(this.uniqueSkus.map(sku => sku.category))].filter(Boolean).sort();
        },
        availableProducts() {
            // Get unique products from uniqueSkus
            return [...new Set(this.uniqueSkus.map(sku => sku.product))].filter(Boolean).sort();
        },
        hasCurrentImage() {
            return !!(this.editedItem.img && this.editedItem.img.trim() !== '');
        },
        filteredTranslations() {
            let filtered = this.translations;

            // Filter by selected shops
            if (this.selectedShops.length > 0) {
                filtered = filtered.filter(item => this.selectedShops.includes(item.shop));
            }

            // Filter by selected products and/or categories
            if (this.selectedProducts.length > 0 || this.selectedCategories.length > 0) {
                let matchingSkus = [];
                
                // Get SKUs from selected products
                if (this.selectedProducts.length > 0) {
                    const productSkus = this.uniqueSkus
                        .filter(sku => this.selectedProducts.includes(sku.product))
                        .map(sku => sku.sku);
                    matchingSkus = [...matchingSkus, ...productSkus];
                }
                
                // Get SKUs from selected categories
                if (this.selectedCategories.length > 0) {
                    const categorySkus = this.uniqueSkus
                        .filter(sku => this.selectedCategories.includes(sku.category))
                        .map(sku => sku.sku);
                    matchingSkus = [...matchingSkus, ...categorySkus];
                }
                
                // Remove duplicates and filter translations
                const uniqueMatchingSkus = [...new Set(matchingSkus)];
                filtered = filtered.filter(item => uniqueMatchingSkus.includes(item.sku));
            }

            // Filter by SKU search
            if (this.skuSearch) {
                filtered = filtered.filter(item => 
                    item.sku && item.sku.toLowerCase().includes(this.skuSearch.toLowerCase())
                );
            }

            return filtered;
        },
        selectedTranslationIds() {
            return this.selectedTranslations.map(item => item.id);
        }
    },

    watch: {
        show: {
            handler(val) {
            if (val) {
                    console.log('📦 Dialog opening, received item:', this.item);
                    
                    // Deep copy to avoid reactivity issues
                    this.editedItem = {
                        ...this.item,
                        // Ensure all fields have default values
                        title: this.item.title || '',
                        sku: this.item.sku || '',
                        lengthCm: this.item.lengthCm || 0,
                        widthCm: this.item.widthCm || 0,
                        heightCm: this.item.heightCm || 0,
                        weight: this.item.weight || 0,
                        pricePerUnit: this.item.pricePerUnit || 0,
                        description: this.item.description || '',
                        img: this.item.img || '',
                        images: this.item.images || []
                    };
                    
                    console.log('📦 EditedItem initialized:', this.editedItem);
                    
                    // Reset upload state
                    this.isUploading = false;
                    this.uploadStatus = '';
                    this.isDragOver = false;
                    
                    // Reset SKU selection state
                    this.selectedShops = [];
                    this.selectedProducts = [];
                    this.selectedCategories = [];
                    this.productSearchInput = '';
                    this.categorySearchInput = '';
                    this.skuSearch = '';
                    this.selectedTranslations = [];
                }
            },
            immediate: true
        },
        item: {
            handler(newVal) {
                if (newVal && this.show) {
                    console.log('📦 Item prop changed while dialog open:', newVal);
                    this.editedItem = { ...newVal };
                }
            },
            deep: true
        }
    },

    methods: {
        async getUniqueSkus() {
            try {
                const response = await PackagingService.getUniqueSkus();
                if (response.status === 200) {
                    // Ensure we're storing objects with all required fields
                    this.uniqueSkus = response.data.map(sku => ({
                        sku: typeof sku === 'string' ? sku : sku.sku,
                        category: typeof sku === 'string' ? 'Unbekannt' : (sku.category || 'Unbekannt'),
                        product: typeof sku === 'string' ? 'Unbekannt' : (sku.product || 'Unbekannt')
                    }));
                    console.log('📦 Total unique SKUs loaded:', this.uniqueSkus.length);
                    console.log('📦 Sample uniqueSkus data:', this.uniqueSkus.slice(0, 3));
                }
            } catch (error) {
                console.error('Error fetching SKUs:', error);
            }
        },

        // SKU methods placeholder - will be implemented later

        removeImage(index) {
            this.editedItem.images.splice(index, 1);
        },

        removeCurrentImage() {
            // Remove the main image
            this.editedItem.img = '';
            console.log('🗑️ Current image removed');
        },

        // Drag and Drop Methods
        handleDragOver(event) {
            event.preventDefault();
            this.isDragOver = true;
        },

        handleDragLeave(event) {
            event.preventDefault();
            this.isDragOver = false;
        },

        handleDrop(event) {
            event.preventDefault();
            this.isDragOver = false;
            
            const files = Array.from(event.dataTransfer.files);
            const imageFiles = files.filter(file => file.type.startsWith('image/'));
            
            if (imageFiles.length > 0) {
                // Only use the first image file for replacement
                this.processFiles([imageFiles[0]]);
            }
        },

        triggerFileInput() {
            this.$refs.fileInput.click();
        },

        onFileInput(event) {
            const files = Array.from(event.target.files);
            if (files.length > 0) {
                this.processFiles(files);
            }
        },

        async processFiles(files) {
            if (files.length === 0) return;
            
            this.isUploading = true;
            this.uploadStatus = this.hasCurrentImage ? 'Ersetze aktuelles Bild...' : 'Lade neues Bild hoch...';

            try {
                // Only process the first file (single image replacement)
                const file = files[0];
                console.log(`📤 Processing file: ${file.name} (${this.hasCurrentImage ? 'replacing existing' : 'new upload'})`);
                
                // Send file to server
                await this.uploadImageToServer(null, file);
                
                this.uploadStatus = this.hasCurrentImage ? 'Bild erfolgreich ersetzt!' : 'Bild erfolgreich hochgeladen!';
                setTimeout(() => {
                    this.isUploading = false;
                    this.uploadStatus = '';
                }, 1500);
                
            } catch (error) {
                console.error('Error uploading file:', error);
                this.uploadStatus = 'Fehler beim Upload';
                setTimeout(() => {
                    this.isUploading = false;
                    this.uploadStatus = '';
                }, 2000);
            }
        },

        async uploadImageToServer(buffer, file) {
            try {
                // Create FormData with the original file
                // Multer middleware will handle the file processing
                const formData = new FormData();
                formData.append('image', file); // Field name must match multer.single('image')
                
                console.log('📤 Uploading file:', file.name, 'Size:', file.size, 'Type:', file.type);
                
                // Send to server with packaging ID in URL
                const response = await PackagingService.uploadImage(this.item._id, formData);
                
                if (response.status === 200) {
                    // Update the main image URL
                    this.editedItem.img = response.data.imageUrl;
                    console.log('✅ Image uploaded and set as main image:', response.data.imageUrl);
                    console.log('📦 Updated packaging:', response.data.packaging);
                } else {
                    throw new Error('Upload failed with status: ' + response.status);
                }
                
            } catch (error) {
                console.error('❌ Error uploading to server:', error);
                console.error('Error details:', error.response?.data || error.message);
                throw error;
            }
        },

        async handleSubmit() {
            this.saving = true;
            try {
                const updatedItem = {
                    ...this.editedItem
                };

                console.log('💾 Saving packaging data:', updatedItem);
                this.$emit('submit', updatedItem);
            } catch (error) {
                console.error('Error saving packaging:', error);
            } finally {
                this.saving = false;
            }
        },

        async getTranslations() {
            try {
                const response = await TranslatorService.getTranslations();
                this.translations = response.data || [];
                console.log('📋 Loaded translations:', this.translations.length, 'entries');
            } catch (error) {
                console.error('Error fetching translations:', error);
                this.translations = [];
            }
        },

        // Shop-related methods

        getShopColor(shop) {
            const colors = {
                'acs': '#2196F3',           // Material Blue
                'amazon': '#FF9900',        // Amazon Orange
                'etsy': '#F56040',          // Etsy Coral/Orange  
                'muckelmeister': '#9C27B0', // Material Purple
                'shopify': '#95BF47'        // Shopify Green
            };
            return colors[shop] || '#9E9E9E';
        },

        getShopColorName(shop) {
            const colorNames = {
                'acs': 'blue',
                'amazon': 'orange', 
                'etsy': 'deep-orange',
                'muckelmeister': 'purple',
                'shopify': 'light-green'
            };
            return colorNames[shop] || 'grey';
        },

        getShopIcon(shop) {
            const icons = {
                'acs': 'mdi-web',
                'amazon': 'mdi-amazon',
                'etsy': 'mdi-etsy', 
                'muckelmeister': 'mdi-store-outline',
                'shopify': 'mdi-shopify'
            };
            return icons[shop] || 'mdi-store-outline';
        },

        // Product-based methods
        getProductSkuCount(product) {
            return this.uniqueSkus.filter(sku => sku.product === product).length;
        },

        getCategorySkuCount(category) {
            return this.uniqueSkus.filter(sku => sku.category === category).length;
        },

        // SKU linking methods
        async updateSkuLinks() {
            const selectedTranslationIds = this.selectedTranslationIds;
            
            try {
                const packageSku = this.item.sku;
                const translationIds = selectedTranslationIds;
                
                const response = await TranslatorService.updateTranslationCartons(packageSku, translationIds);
            
                if (response.status === 200) {
                    console.log('✅ SKU-Verknüpfungen erfolgreich aktualisiert');
                    await this.getTranslations();
                } else {
                    console.error('Error updating SKU links:', error);
                }
            } catch (error) {
                console.error('Error updating SKU links:', error);
                console.error('Error details:', error.response?.data || error.message);
            }
        },

        // Selection management methods
        selectAllMatchingSkus() {
            this.selectedTranslations = [...this.filteredTranslations];
            console.log(`✅ Selected all ${this.filteredTranslations.length} matching SKUs`);
        },

        clearAllSelections() {
            this.selectedTranslations = [];
            console.log('🗑️ Cleared all selections');
        },

        clearSelection() {
            this.selectedTranslations = [];
            console.log('🗑️ Cleared selection');
        }
    },

    created() {
        this.getUniqueSkus();
        this.getTranslations();
    }
}
</script>

<style scoped>
.v-tab {
    text-transform: none;
    letter-spacing: 0;
}

.v-card__title {
    font-size: 1.25rem;
}

.v-menu {
    display: inline-block;
}

/* Packaging Edit Dialog Styling */
.packaging-edit-dialog {
    position: relative;
    max-height: 90vh;
    overflow: hidden;
}

.close-button-fixed {
    position: absolute !important;
    top: 8px;
    right: 8px;
    z-index: 10;
    background-color: rgba(255, 255, 255, 0.9) !important;
}

/* Header Section */
.packaging-header {
    background: linear-gradient(135deg, #1976d2, #1565c0);
    color: white;
    padding: 20px;
    border-radius: 4px 4px 0 0;
}

.header-content {
    display: flex;
    gap: 20px;
    align-items: flex-start;
}

.header-image {
    width: 120px;
    height: 120px;
    border-radius: 12px;
    overflow: hidden;
    background-color: white;
    border: 2px solid rgba(255, 255, 255, 0.2);
    flex-shrink: 0;
}

.header-image img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.no-image-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
}

.header-info {
    flex: 1;
    min-width: 0;
}

.packaging-title {
    font-size: 1.75rem;
    font-weight: 700;
    margin-bottom: 16px;
    color: white;
}

.packaging-meta {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.meta-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.meta-label {
    font-size: 0.875rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.8);
    min-width: 100px;
}

.meta-value {
    font-size: 1rem;
    font-weight: 600;
    color: white;
}

.sku-badge {
    background-color: rgba(255, 255, 255, 0.2);
    padding: 4px 12px;
    border-radius: 16px;
    font-family: monospace;
}

/* Content Sections */
.packaging-content {
    overflow-y: auto;
    padding: 24px !important;
}

.edit-section,
.media-section,
.sku-section {
    margin-bottom: 32px;
}

.section-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
}

.section-card {
    border-radius: 12px;
    border: 1px solid #e0e0e0;
}

/* SKU Assignment Styling */
.shop-selection-area {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #e9ecef;
}

.shop-checkboxes {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.shop-checkbox {
    margin: 0 !important;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    background-color: white;
    transition: all 0.3s ease;
}

.shop-checkbox:hover {
    background-color: #f5f9ff;
    border-color: #1976d2;
}

.shop-label {
    display: flex;
    align-items: center;
}

.search-filter-area {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #e9ecef;
}

.results-summary {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.sku-table-container {
    border-radius: 8px;
    overflow: hidden;
}


.selection-summary {
    display: flex;
    align-items: center;
    gap: 8px;
}

.filter-selection-area {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #e9ecef;
}


.sku-preview-placeholder,
.sku-empty-state {
    text-align: center;
    padding: 40px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    background-color: #fafafa;
    border-radius: 8px;
    border: 1px dashed #e0e0e0;
}

/* Image Upload Area Styling */
.image-upload-area {
    border: 2px dashed #e0e0e0;
    border-radius: 12px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #fafafa;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.image-upload-area:hover {
    border-color: #1976d2;
    background-color: #f5f9ff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.1);
}

.image-upload-area.drag-over {
    border-color: #1976d2;
    background-color: #e3f2fd;
    border-style: solid;
    transform: scale(1.02);
    box-shadow: 0 6px 20px rgba(25, 118, 210, 0.2);
}

.image-upload-area.uploading {
    border-color: #4caf50;
    background-color: #f1f8e9;
    pointer-events: none;
}

.image-upload-area.has-image {
    border-style: solid;
    border-color: #4caf50;
    background-color: #f8f9fa;
    min-height: 300px;
}

/* Current Image Display */
.current-image-display {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.current-image-container {
    position: relative;
    width: 200px;
    height: 200px;
    border-radius: 12px;
    overflow: hidden;
    background-color: white;
    border: 2px solid #e0e0e0;
}

.current-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.current-image-container:hover .image-overlay {
    opacity: 1;
}

.overlay-text {
    color: white;
    font-size: 0.875rem;
    font-weight: 500;
    margin: 0;
}

.image-actions {
    display: flex;
    gap: 12px;
    align-items: center;
}

/* Upload States */
.upload-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 20px;
}

.upload-progress {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

/* Responsive adjustments */
@media (max-width: 600px) {
    .image-upload-area {
        padding: 20px 15px;
        min-height: 180px;
    }
    
    .upload-empty-state h3 {
        font-size: 1.1rem;
    }
    
    .upload-empty-state p {
        font-size: 0.9rem;
    }
    
    .current-image-container {
        width: 150px;
        height: 150px;
    }
    
    .image-actions {
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
    
    .image-actions .v-btn {
        width: 100%;
    }
    
    .packaging-header {
        padding: 16px;
    }
    
    .header-content {
        flex-direction: column;
        gap: 16px;
        text-align: center;
    }
    
    .header-image {
        width: 100px;
        height: 100px;
        align-self: center;
    }
    
    .packaging-title {
        font-size: 1.5rem;
    }
    
    .packaging-meta {
        align-items: center;
    }
    
    .meta-row {
        justify-content: center;
    }
    
    .packaging-content {
        padding: 16px !important;
    }
    
    .edit-section,
    .media-section,
    .sku-section {
        margin-bottom: 24px;
    }
}

/* Compact Header Styles */
.packaging-header-compact {
    background: linear-gradient(135deg, #1976d2, #1565c0);
    color: white;
    padding: 12px 20px;
    border-radius: 4px 4px 0 0;
}

.header-content-compact {
    display: flex;
    gap: 16px;
    align-items: center;
}

.header-image-compact {
    flex-shrink: 0;
}

.header-image-compact img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 6px;
    border: 2px solid rgba(255, 255, 255, 0.3);
}

.no-image-placeholder-compact {
    width: 50px;
    height: 50px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid rgba(255, 255, 255, 0.3);
}

.header-info-compact {
    flex: 1;
    min-width: 0;
}

.packaging-title-compact {
    font-size: 1.25rem;
    font-weight: 600;
    color: white;
    margin: 0 0 6px 0;
}

.packaging-details-compact {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.detail-chip {
    background: rgba(255, 255, 255, 0.15);
    color: white;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 0.8rem;
    font-weight: 500;
    white-space: nowrap;
}

/* Full Screen Dialog */
.full-screen-dialog {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    margin: 0 !important;
    border-radius: 0 !important;
}

.full-screen-dialog .v-card__text {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    padding-bottom: 0 !important;
}

/* Remove any default dialog padding/margin */
.v-dialog > .v-card {
    margin: 0 !important;
}

.packaging-edit-dialog {
    margin: 0 !important;
    height: 95vh !important;
}

.packaging-content {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

/* SKU Table Container */
.sku-table-container {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
}

/* Compact Footer */
.compact-footer {
    padding: 8px 16px !important;
    min-height: 48px !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    flex-shrink: 0 !important;
    border-top: 1px solid #e0e0e0;
}

/* SKU Linking Section - No internal scrolling */
.sku-linking-section {
    max-height: none !important;
    overflow-y: visible !important;
}

/* Two Column Layout */
.top-sections {
    margin-bottom: 32px;
}

.top-sections .edit-section,
.top-sections .media-section {
    height: 100%;
}

.top-sections .section-card {
    height: calc(100% - 60px); /* Account for section title */
}

/* Responsive adjustments */
@media (max-width: 1264px) {
    .top-sections .pr-lg-3 {
        padding-right: 12px !important;
    }
    
    .top-sections .pl-lg-3 {
        padding-left: 12px !important;
    }
}

.sku-linking-section {
    max-height: none !important;
    overflow-y: inherit !important;
}
</style>